import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Injectable,
} from "@angular/core";
import { MessageTrayService } from "./message-tray.service";
import { MessageTrayData } from "./message-tray.data";
import { Sort } from "@angular/material/sort";

@Component({
    selector: "app-message-tray",
    templateUrl: "./message-tray.component.html",
    styleUrls: ["./message-tray.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Injectable({
  providedIn: "root",
})
export class MessageTrayComponent implements OnInit {
  messages: MessageTrayData[] = [];
  filteredMessages: MessageTrayData[] = [];
  isDebugMode = false;

  // filters and identifiers
  filterText = '';
  activeTab: 'ALL' | 'ERROR' | 'INFO' = 'ALL';
  userId: string | null = null;
  ccn: string | null = null;

  currentSort: Sort = {
    active: 'timestamp', direction: 'desc'
  };

  constructor(
    readonly mTrayServ: MessageTrayService,
    readonly changeDetection: ChangeDetectorRef
  ) { }

  toggleDebug() {
    this.isDebugMode = !this.isDebugMode;
  }

  ngOnInit() {
    this.mTrayServ.getUserContext().subscribe(userContext => {
      this.userId = userContext.userId;
      this.ccn = userContext.ccn;
      this.changeDetection.markForCheck();
    });

    this.mTrayServ.getMessage().subscribe((message) => {
      this.messages.push({
        timestamp: message.timestamp,
        logLevel: message.logLevel,
        message: message.message,
      });

      this.applyFilter();
      this.changeDetection.markForCheck();
    });
  }

  applyFilter() {
    this.filteredMessages = this.messages.filter((msg) => {
      const level =
        this.activeTab === 'ALL' || msg.logLevel === this.activeTab;
      const text =
        !this.filterText ||
        JSON.stringify(msg.message)
          .toLowerCase()
          .includes(this.filterText.toLowerCase());
      return level && text;
    });
    if (this.activeTab !== 'ALL' && this.currentSort.active === 'level') {
      this.currentSort = {
        active: 'timestamp',
        direction: 'desc'
      };
    }
    this.sortData(this.currentSort);
  }

  sortData(event: Sort): any {
    this.currentSort = event;

    if (!event.active || event.direction === "") {
      event = {
        active: 'timestamp',
        direction: 'desc'
      };
    }

    const isAsc = event.direction === "asc";

    this.filteredMessages.sort((a, b) => {

      if (event.active === "timestamp") {
        return this.compare(a.timestamp, b.timestamp, isAsc);
      }
      else if (event.active === "level") {
        return this.compare(a.logLevel, b.logLevel, isAsc);
      }
      return 0;
    });
  }

  compare(
    a: number | string | Date,
    b: number | string | Date,
    isAsc: boolean
  ): number {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  hasMultipleLevels(): boolean {
    const levels = new Set(
      this.filteredMessages.map(msg => msg.logLevel)
    );

    return levels.size > 1;
  }
}
